import { fontWeights } from "@dana/MobiusOverrides/styles/typography";
import { savedOrderDetailsTotalStyles } from "@dana/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsTotal";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

savedOrderDetailsTotalStyles.cartTotal = mergeToNew(savedOrderDetailsTotalStyles.cartTotal, {
    container: {
        css: css`
            @media print {
                padding: 0;
                background: transparent;
                > div[class*="GridOffset"] {
                    width: 100%;
                    margin: 0;
                    > div {
                        padding: 1px; 
                    } 
                }
            }
        `,
    },
    valueGridItem: {
        css: css`
            @media print {
                display: inline-flex !important;
            }
        `,
    },
    subtotalLabel: {
        weight: fontWeights.regular,
    },
    promotionLabel: {
        weight: fontWeights.regular,
    },
    discountsLabel: {
        weight: fontWeights.regular,
    },
    shippingAndHandlingLabel: {
        weight: fontWeights.regular,
    },
    otherChargesLabel: {
        weight: fontWeights.regular,
    },
    totalLabel: {
        weight: fontWeights.regular,
    },
    subtotalValue: {
        weight: fontWeights.semiBold,
    },
    promotionValue: {
        weight: fontWeights.semiBold,
    },
    discountsValue: {
        weight: fontWeights.semiBold,
    },
    shippingAndHandlingValue: {
        weight: fontWeights.semiBold,
    },
    otherChargesValue: {
        weight: fontWeights.semiBold,
    },
    taxValue: {
        weight: fontWeights.semiBold,
    },
    totalValue: {
        weight: fontWeights.semiBold,
    },
});
